module.exports = __webpack_public_path__ + "static/media/slider_deactive_yl.c32649d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider_deactive_yl.svg
// module id = 130
// module chunks = 0